<mat-sidenav-container
  [hasBackdrop]="isSmallScreen"
  class="w-full bg-background-primary h-full"
  (backdropClick)="setActiveCell(null)"
  y42ColumnTypeCssStyles
  [attr.data-test]="'table-data-ag-grid'"
>
  <mat-sidenav
    #sidenav
    [mode]="isSmallScreen ? 'over' : 'side'"
    [opened]="!!activeCell"
    [position]="'start'"
    class="data-display-sidebar"
  >
    <div *ngIf="activeCell">
      <button
        mat-icon-button
        class="absolute"
        style="top: 10px; right: 12px"
        (click)="setActiveCell(null)"
        [intercomTarget]="'01-table-data-ag-grid-27811'"
      >
        <fa-icon class="fs-8 text-gray-600" [icon]="['fal', 'times']"></fa-icon>
      </button>
      <div class="data-display-title aligner-start">
        <div style="width: 23px">
          <y42-column-type-icon [type]="activeCell.column.data_type"></y42-column-type-icon>
        </div>
        <div class="truncate" style="width: calc(100% - 35px)">
          <p class="fs-06 text-gray-600" style="padding-left: 7px" *ngIf="activeCell.column.field_name">
            {{ activeCell.column.field_name }}
          </p>
          {{ activeCell.column.description }}
        </div>
      </div>
      <div class="data-display-body">
        <div *ngIf="cellLoading" class="fs-08 font-normal text-gray-600">Calculating...</div>
        <ng-container *ngIf="!cellLoading">
          <span *ngIf="activeCell.parsedJSON === null">NULL</span>
          <ngx-json-viewer *ngIf="activeCell.parsedJSON !== null" [json]="activeCell.parsedJSON"></ngx-json-viewer>
        </ng-container>
      </div>
    </div>
  </mat-sidenav>
  <mat-sidenav-content>
    <div class="chart-preview-box z-depth-1 relative z-index-3" *ngIf="activeHeaderColumn" @displayBox>
      <div class="absolute w-full z-index-3" *ngIf="activeCardinalityLoading && activeCardinalityLoading === true">
        <mat-progress-bar mode="indeterminate" class="w-full"></mat-progress-bar>
      </div>
      <button
        class="small-icon-button absolute z-index-3"
        style="top: 10px; right: 10px"
        mat-icon-button
        (click)="analyzeColumn(null)"
        [intercomTarget]="'01-table-data-ag-grid-47823'"
      >
        <fa-icon class="fs-8 text-gray-600" [icon]="['fal', 'times']"></fa-icon>
      </button>

      <y42-table-column-stats
        *ngIf="!activeCardinalityLoading"
        class="aligner w-full h-full"
        [activeHeaderColumn]="activeHeaderColumn"
        [activeCardinality]="activeCardinality"
      ></y42-table-column-stats>
    </div>
    <div *ngIf="verticalButtonLayout" class="border-b flex p-[4px]">
      <button
        mat-button
        apparance="outline"
        color="primary"
        (click)="openTogglePanel('columns')"
        [intercomTarget]="'table-data-aggrid-columns'"
      >
        <mat-icon>view_column</mat-icon>
        &nbsp;Columns
      </button>
      <button
        mat-button
        apparance="outline"
        color="primary"
        (click)="openTogglePanel('filters')"
        [intercomTarget]="'table-data-aggrid-filters'"
      >
        <mat-icon>filter_list</mat-icon>
        &nbsp;Filters
      </button>
      <button
        mat-button
        color="primary"
        matTooltip="Export visible rows, max 100000"
        apparance="outline"
        class="ml-auto"
        (click)="exportData()"
        [intercomTarget]="'table-data-aggrid-export'"
      >
        <mat-icon>get_app</mat-icon>
        &nbsp;Export
      </button>
    </div>
    <div
      class="relative"
      [ngStyle]="{
        height: !(activeCardinality && activeHeaderColumn)
          ? verticalButtonLayout
            ? 'calc(100% - 80px)'
            : 'calc(100% - 40px)'
          : 'calc(100% - 220px)'
      }"
    >
      <div class="hidden-layer" *ngIf="gridLoading">
        <mat-progress-bar mode="indeterminate" class="w-full"></mat-progress-bar>
      </div>

      <ag-grid-angular
        #agGrid
        *ngIf="!showTable"
        class="ag-theme-material-datos"
        [columnDefs]="columnColDefs"
        [rowData]="rowDataColumns"
        [gridOptions]="columnGridOptions"
        [components]="frameworkComponents"
        (gridReady)="onColumnGridReady($event)"
        [y42AgGridIntercomTargetDirective]="'01-table-data-ag-grid-74371'"
      >
      </ag-grid-angular>

      <ag-grid-angular
        #agGrid
        [hidden]="!showTable"
        id="myGrid"
        class="ag-theme-material-datos"
        [columnDefs]="columnDefs"
        [customChartThemes]="$any(customChartThemes)"
        [gridOptions]="gridOptions"
        [rowData]="rowData"
        [components]="frameworkComponents"
        (gridReady)="onGridReady($event)"
        (modelUpdated)="onModelUpdated()"
        [y42AgGridIntercomTargetDirective]="'01-table-data-ag-grid-74370'"
      >
      </ag-grid-angular>
    </div>
    <y42-table-footer
      [size]="size"
      [showPreviewRow]="showTable"
      [rows]="totalRows"
      [showSize]="showSize"
      [columnsLength]="columns.length"
      [previewRows]="previewRows"
      [cellRangesStats]="state.cellRangesStats"
    >
    </y42-table-footer>
    <!-- <mat-button-toggle-group
      (change)="onViewChanged()"
      [(ngModel)]="showTable"
      class="toggle-group-deep-style absolute"
      style="bottom: 2px; right: 2px"
    >
      <mat-button-toggle [value]="true" [matTooltip]="'Data View'">
        <fa-icon class="fs-07" [icon]="['fal', 'grip-lines-vertical']"></fa-icon>
      </mat-button-toggle>
      <mat-button-toggle [value]="false" [matTooltip]="'Column View'">
        <fa-icon class="fs-07" [icon]="['fal', 'grip-lines']"></fa-icon>
      </mat-button-toggle>
    </mat-button-toggle-group>-->
  </mat-sidenav-content>
</mat-sidenav-container>
